/* eslint-disable no-undef */
<template>
  <div data-v-61dd7a3d id="sticky-header" class="main-header-area home-2">
    <div data-v-61dd7a3d class="container-xl">
      <div data-v-61dd7a3d class="row align-items-center">
        <div data-v-61dd7a3d class="col-6 col-lg-12">
          <div
            data-v-61dd7a3d
            class="header_wrap d-flex justify-content-between align-items-center"
          >
            <div data-v-61dd7a3d class="header_left">
              <div data-v-61dd7a3d class="logo">
                <router-link to="/" class="active">
                  <!-- <img
                    id="logo"
                    alt="Logo"
                    :src="sticky === true ? logo[1] : logo[0]"
                    sizes="(max-width: 289px) 100vw, 289px"
                  /> -->
                  <img
                    id="logo"
                    alt="Logo"
                    src="@/assets/img/logo.png"
                    sizes="(max-width: 289px) 100vw, 289px"
                  />
                </router-link>
              </div>
            </div>
            <div data-v-61dd7a3d class="header_right d-flex align-items-center">
              <div data-v-61dd7a3d class="main-menu d-none d-lg-block">
                <ul data-v-61dd7a3d id="navigation">
                  <li data-v-61dd7a3d>
                    <a data-v-61dd7a3d href="#how-it-works">
                      {{ $t("footer.menu-1.how-it-works") }}
                    </a>
                  </li>
                  <li data-v-61dd7a3d>
                    <a data-v-61dd7a3d href="#download">
                      {{ $t("header.menu_txt_one") }}
                    </a>
                  </li>
                  <li data-v-61dd7a3d>
                    <a data-v-61dd7a3d href="#plans">
                      {{ $t("header.menu_txt_two") }}
                    </a>
                  </li>
                  <li data-v-61dd7a3d>
                    <a data-v-61dd7a3d href="#subscribe">
                      {{ $t("header.menu_txt_three") }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div data-v-61dd7a3d class="d-lg-flex d-none">
              <ul data-v-61dd7a3d class="nav flex align-bottom justify-between">
                <li data-v-61dd7a3d class="nav-item pl-3">
                  <a data-v-61dd7a3d href="#plans" class="btn header-btn">
                    {{ $t("header.menu_iniciar_session") }}
                  </a>
                </li>
                <li data-v-61dd7a3d>
                  <LocaleSwitcher />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div data-v-61dd7a3d class="col-6">
          <div data-v-61dd7a3d class="mobile_menu d-block d-lg-none">
            <nav
              data-v-61dd7a3d
              id="dropdown-right"
              class="dropdown b-dropdown m-2 btn-group"
            >
              <!---->

              <ul
                role="menu"
                tabindex="-1"
                aria-labelledby="dropdown-right__BV_toggle_"
                class="dropdown-menu dropdown-menu-right"
              >
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                    >Descarga nuestra app</a
                  >
                </li>
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                    >Conoce nuestros planes</a
                  >
                </li>
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                    >Suscríbete</a
                  >
                </li>
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                    >Testimonio</a
                  >
                </li>
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                    >Blog</a
                  >
                </li>
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                    >Contáctenos</a
                  >
                </li>
                <li data-v-61dd7a3d role="presentation">
                  <a
                    role="menuitem"
                    href="#"
                    target="_self"
                    class="dropdown-item"
                  >
                    <a data-v-61dd7a3d href="#" class="btn header-btn"
                      >Comprar Ahora</a
                    >
                  </a>
                </li>
                <div data-v-61dd7a3d class="row justify-content-center">
                  <div data-v-61dd7a3d class="col-7">
                    <LocaleSwitcher />
                  </div>
                </div>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// window.$ = window.jQuery = require("jquery");
import LocaleSwitcher from "@/components/home/LocaleSwitcher";
export default {
  components: {
    LocaleSwitcher
  },
  data() {
    return {
      logo: [
        require("@/assets/img/logo.png"),
        require("@/assets/img/Group_darklogo.png")
      ],
      sticky: false
    };
  },
  mounted() {
    let self = this;
    $(window).on("load", function() {
      $("#status").fadeOut();
      $("#preloader")
        .delay(550)
        .fadeOut("slow");
      $("body")
        .delay(550)
        .css({
          overflow: "visible"
        });
    });
    // ****************************
    // :: TOP Menu Active Code
    // ****************************

    $(window).on("scroll", function() {
      // eslint-disable-next-line no-undef
      let scroll = $(window).scrollTop();

      if (scroll < 400) {
        $("#sticky-header").removeClass("sticky");
        $("#logo").attr("src", require("@/assets/img/logo.png"));
        self.sticky = false;
        $("#back-top").fadeIn(700);
      } else {
        $("#sticky-header").addClass("sticky");
        $("#logo").attr("src", require("@/assets/img/Group_darklogo.png"));
        self.sticky = true;
        $("#back-top").fadeIn(700);
      }
    });

    // ****************************
    // :: Mobile Menu Active Code
    // ****************************

    // mobile_menu
    var menu = $("ul#navigation");
    if (menu.length) {
      menu.slicknav({
        prependTo: ".mobile_menu",
        closedSymbol: "+",
        openedSymbol: "-"
      });
    }
  }
};
</script>
